import React from 'react';
import { JobsitePulseCamera } from 'containers/jobsite/tabs/jobsitePulse/data/types';
import {
  VideoFrame,
  VideoCaption,
} from 'containers/jobsite/tabs/jobsitePulse/components/cameras/video';
import { DroneDeploymentMap } from './DroneDeploymentMap';
import { DroneDeploymentStatus } from './DroneDeploymentStatus';
import { useDroneDeploy } from './DroneDeployContext';
import { DRONE_FEED_URL } from './droneDemoData';
import { DroneCamera } from './types';

export function isIdleDroneCamera(
  cam?: JobsitePulseCamera,
): cam is DroneCamera {
  const drone = cam as DroneCamera | undefined;
  return drone?.type === 'drone' && drone?.droneStatus === 'idle';
}

export type DroneMainCameraProps = {
  selectedCamera: DroneCamera;
  className?: string;
};

/**
 * Renders the drone deploy demo phases (map → deploying → ready). Only rendered
 * by MainCamera when the selected camera is an idle drone.
 */
export function DroneMainCamera({
  selectedCamera,
  className,
}: DroneMainCameraProps): React.ReactElement | null {
  const droneDeploy = useDroneDeploy();
  if (!droneDeploy) return null;

  if (droneDeploy.phase === 'map') {
    return (
      <div className={className}>
        <VideoFrame>
          <VideoCaption text={selectedCamera.name} suppressWhenNoText />
          <DroneDeploymentMap
            droneName={selectedCamera.name}
            onDeploy={droneDeploy.deploy}
          />
        </VideoFrame>
      </div>
    );
  }

  if (droneDeploy.phase === 'deploying') {
    return (
      <div className={className}>
        <VideoFrame>
          <DroneDeploymentStatus
            droneName={selectedCamera.name}
            coordinates={droneDeploy.coordinates}
            onReady={droneDeploy.setReady}
          />
        </VideoFrame>
      </div>
    );
  }

  if (droneDeploy.phase === 'ready') {
    return (
      <div className={className}>
        <VideoFrame>
          <VideoCaption text={selectedCamera.name} suppressWhenNoText />
          <VideoCaption text="LIVE" color="purple" align="right" />
          <video
            src={DRONE_FEED_URL}
            className="odin-h-full odin-w-full odin-object-contain"
            autoPlay
            loop
            muted
          />
        </VideoFrame>
      </div>
    );
  }

  return null;
}
